import React from 'react';

interface ContainerPropsInterface {
    children: React.ReactNode;
}

export const Container: React.FC<ContainerPropsInterface> = ({ children }) => {
    return <div className="mx-auto w-full max-w-[1288px] px-[2.4rem]">{children}</div>;
};
